import { call, put } from 'redux-saga/effects';

import { creators as MTDBActions } from '../../Reducers/MTDB';
import Api from '../../Api/DefaultApi';

export function* getTables() {
  try {
    const response = yield call(Api.getTables, null);
    if (response.status === 200) {
      yield put(MTDBActions.mtdbSuccess({ tables: response.data }));
    } else {
      yield put(MTDBActions.mtdbFailure(response.message));
    }
  } catch (e) {
    yield put(MTDBActions.mtdbFailure(e));
  }
}
